/**
 *
 * @param {Object} dateTimeObject
 * @param {string} dateTimeObject.timeRange the start time and end time of lesson.
 * @param {string} dateTimeObject.startDate the start date of lesson.
 * @param {boolean} dateTimeObject.startTomorrow check if the lesson starts tomorrow by start time.
 * @param {boolean} dateTimeObject.startToday check if the lesson starts today by start time.
 * @param {boolean} dateTimeObject.isLive check if the lesson is streaming now.
 * @param {function} t i18next translation function
 *
 * @returns {string}
 */

export default function getDateTimeWithStatus(
  { startTomorrow, startToday, startDate, timeRange, isLive } = {},
  t,
) {
  if (isLive) return `${t('live:home.content.today.video.desc')}．${timeRange}`;

  if (startToday) return `${t('live:home.content.today.title')}, ${timeRange}`;

  if (startTomorrow)
    return `${t('live:home.content.upcoming.desc')}, ${timeRange}`;

  return `${startDate}, ${timeRange}`;
}
